<template>
  <div :id="params.channel" :params="params" style="display: none"></div>
</template>

<script lang="ts">
import { useActionCableStore } from "~/stores/actionCableStore"
import { useUserStore } from "~/stores/userStore"

const appEnv = useRuntimeConfig().public.appEnv

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const userStore = useUserStore()
    const actionCableStore = useActionCableStore()

    if (userStore.authToken) {
      actionCableStore.init(userStore.authToken)
    } else if (appEnv !== "production") {
      console.log("[ActionCable] Not initialized: missing auth token")
    }

    return {
      userStore,
      actionCableStore,
    }
  },

  data() {
    return {
      state: {
        subscription: null,
      },
    }
  },

  mounted() {
    this.subscribe()
  },

  beforeUnmount() {
    this.unsubscribe()
  },

  methods: {
    subscribe() {
      if (this.state.subscription) {
        this.unsubscribe()
      }

      this.state.subscription = this.actionCableStore.actioncable?.subscriptions.create(this.params, {
        connected: this.connected,
        disconnected: this.disconnected,
        rejected: this.rejected,
        received: this.received,
      })

      if (appEnv !== "production") {
        console.log(`[ActionCable] Subscribed: ${this.params.channel}`, this.params)
      }
    },

    unsubscribe() {
      if (!this.state.subscription) {
        return
      }

      this.actionCableStore.actioncable?.subscriptions.remove(this.state.subscription)
      this.state.subscription = null

      if (appEnv !== "production") {
        console.log(`[ActionCable] Unsubscribed: ${this.params.channel}`, this.params)
      }
    },

    connected() {
      if (appEnv !== "production") {
        console.log(`[ActionCable] Connected: ${this.params.channel}`, this.params)
      }
    },

    disconnected() {
      if (appEnv !== "production") {
        console.log(`[ActionCable] Disconnected: ${this.params.channel}`, this.params)
      }
    },

    rejected() {
      if (appEnv !== "production") {
        console.log(`[ActionCable] Rejected: ${this.params.channel}`, this.params)
      }
    },

    received(payload: any) {
      this.$emit(payload.event, payload.data)

      if (appEnv !== "production") {
        console.log(`[ActionCable] Received: ${this.params.channel}`, this.params)
        console.log("Payload:", payload)
      }
    },
  },
}
</script>
